<template>
  <pt-doctor-manage class="pt-doctor-manage__page"></pt-doctor-manage>
</template>

<script>
import PtDoctorManage from 'cps/hospital-and-doctor-manage/pt-doctor-manage/withData'
export default {
  name: 'pt-doctor-manage__view',
  components: {
    'pt-doctor-manage': PtDoctorManage
  }
}
</script>
